export default "__VITE_ASSET__5e61a7c2__"